import { ApiEvent } from '@/api';
import { addMinutes, parseLocal, toLocalInputValue } from '@/utils/datetime';
import { buildICS, downloadICS } from '@/utils/ics';

/** Default duration for events without explicit end (minutes). */
export const DEFAULT_DURATION_MIN = 90;

/** Normalize event start/end with sensible fallbacks. */
export function eventStartISO(ev: ApiEvent): string {
  return ev.start_ts ?? (ev.start_date ? `${ev.start_date}T00:00:00` : '');
}
export function eventEndISO(ev: ApiEvent): string {
  if (ev.end_ts) return ev.end_ts;
  if (ev.end_date) return `${ev.end_date}T00:00:00`;
  const s = eventStartISO(ev);
  if (!s) return '';
  return toLocalInputValue(addMinutes(parseLocal(s), DEFAULT_DURATION_MIN)) + ':00';
}

/** Small helpers for ICS filename & content. */
export function slugify(s: string) {
  return (s || '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '');
}

export function makeICSForEvent(ev: ApiEvent, override?: { title?: string; location?: string }) {
  const start = eventStartISO(ev);
  const end = eventEndISO(ev);
  return buildICS({
    uid: `${ev.id}@${(typeof window !== 'undefined' && window.location.host) || 'myevents'}`,
    title: override?.title ?? ev.title,
    start,
    end,
    location: override?.location ?? ev.location ?? undefined,
    url: ev.url ?? undefined,
    description: ev.notes ?? undefined
  });
}

export function downloadICSForEvent(ev: ApiEvent, titleOverride?: string, locationOverride?: string) {
  const t = titleOverride || ev.title || 'event';
  const ics = makeICSForEvent(ev, { title: t, location: locationOverride });
  downloadICS(`${slugify(t)}.ics`, ics);
}
